import './subjects.css';

export const Subjects = () => {
    return (
        <section className='subjects'>
            <h1 className='page_title extra_margin'>Subjects taught in our school</h1>
            <ul className='subject_list'>
                <li>Hindi</li>
                <li>English</li>
                <li>Mathematics</li>
                <li>Science</li>
                <li>Social Science</li>
                <li>Home Science</li>
                <li>Drawing</li>
            </ul>
        </section>
    )
}
